export const ASYNC_FETCH = 'ILD_Destination/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ILDDESTINATION = 'ILD_Destination/ASYNC_FETCH_SUCCESS_ILDDESTINATION';
export const ASYNC_FETCH_FAILURE = 'ILD_Destination/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_Destination/ASYNC_FETCH_INVALIDATE';

export const ASYNC_FETCH_SUCCESS = 'ILD_Destination/ASYNC_FETCH_SUCCESS';
export const DEVICE_COMPATIBLE_CHECK = 'ILD_Destination/DEVICE_COMPATIBLE_CHECK';
export const DEVICE_COMPATIBLE_FLAG = 'ILD_Destination/DEVICE_COMPATIBLE_FLAG';
export const UPDATE_SELECTED_LINE_DETAILS = 'ILD_Destination/UPDATE_SELECTED_LINE_DETAILS';
export const UPDATE_SELECTED_LINE_DETAILS_EFFECTIVE_DATE = 'ILD_Destination/UPDATE_SELECTED_LINE_DETAILS_EFFECTIVE_DATE';
export const EFFECTIVE_DATE_RESPONSE = 'ILD_Destination/EFFECTIVE_DATE_RESPONSE';
export const CLEAR_ALL_LINES = 'ILD_Destination/CLEAR_ALL_LINES';
export const APPLY_TO_ALL_LINES_EFFECTIVE_DATE = 'ILD_Destination/APPLY_TO_ALL_LINES_EFFECTIVE_DATE';
export const UPDATE_GC_PLAN = 'ILD_Destination/UPDATE_GC_PLAN';
export const UPDATE_COUNTRY_LIST = 'ILD_Destination/UPDATE_COUNTRY_LIST';
export const UPDATE_SELECTED_COUNTRY = 'ILD_Destination/UPDATE_SELECTED_COUNTRY';
export const APPLY_ALL_SELECTED_COUNTRY_DETAILS = 'ILD_Destination/APPLY_ALL_SELECTED_COUNTRY_DETAILS';
export const UPDATED_SUBMITTED_COUNTRIES = 'ILD_Destination/UPDATED_SUBMITTED_COUNTRIES';
export const UPDATE_FRAUD_MODAL_FLAG = 'ILD_Destination/UPDATE_FRAUD_MODAL_FLAG';
export const SET_SELECTED_DEST_LIST = 'ILD_Destination/SET_SELECTED_DEST_LIST';
/**
 * action types
 * @type {string}
 */
// export const formatDate = (val) => {
//     const value = new Date(val);
//     let dd = value.getDate();
//     let mm = value.getMonth() + 1; // January is 0!
//     const yyyy = value.getFullYear();
//     if (dd < 10) {
//         dd = '0' + dd;
//     }
//     if (mm < 10) {
//         mm = '0' + mm;
//     }

//     return mm + '/' + dd + '/' + yyyy;
// };

/**
 * action types
 * @type {string}
 */
